import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=6e84d7b7&scoped=true&"
import script from "./ReceiptList.vue?vue&type=script&lang=js&"
export * from "./ReceiptList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptList.vue?vue&type=style&index=0&id=6e84d7b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84d7b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VContainer,VIcon,VTab,VTabs})
